import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

import {
    AccountRules,
    CompensationRules,
    CustomRules,
    EventRules,
    EventTicketRules,
    FieldValidatorsMap,
    PosRules,
    ReceiptRules,
    ServiceRules,
    ServiceTicketRules,
    UserRules,
} from './rules';
import { EventDiscountRules } from './rules/event/event-discount.rules';
import { NoRulesRules } from './rules/no-rules/no-rules.rules';

import { ObjectLike } from 'app/interfaces';

@Injectable()
export class ValidatorsService {
    getAddMoneyForm(formFrom: ObjectLike = {}): FormGroup {
        return new AccountRules().getAddMoneyForm(formFrom);
    }

    getCampaignForm(formFrom: ObjectLike = {}): FormGroup {
        return new UserRules().getCampaignForm(formFrom);
    }

    getCompensationStoreForm(formFrom: ObjectLike = {}): FormGroup {
        return new CompensationRules().getStoreForm(formFrom);
    }

    getCompensationUpdateForm(formFrom: ObjectLike = {}): FormGroup {
        return new CompensationRules().getUpdateForm(formFrom);
    }

    getCustomRulesForm(fieldRules: FieldValidatorsMap, formFrom: ObjectLike = {}): FormGroup {
        return new CustomRules(fieldRules).getForm(formFrom);
    }

    getEventDiscountStoreForm(formFrom: ObjectLike = {}): FormGroup {
        return new EventDiscountRules().getStoreForm(formFrom);
    }

    getEventStoreForm(formFrom: ObjectLike = {}): FormGroup {
        return new EventRules().getStoreForm(formFrom);
    }

    getEventTicketStoreForm(formFrom: ObjectLike = {}): FormGroup {
        return new EventTicketRules().getStoreForm(formFrom);
    }

    getEventTicketUpdateForm(formFrom: ObjectLike = {}): FormGroup {
        return new EventTicketRules().getUpdateForm(formFrom);
    }

    getEventUpdateForm(formFrom: ObjectLike = {}): FormGroup {
        return new EventRules().getUpdateForm(formFrom);
    }

    getNoRulesForm(formFrom: ObjectLike = {}): FormGroup {
        return new NoRulesRules().getNoRulesForm(formFrom);
    }

    getPosDiscountStoreForm(formFrom: ObjectLike = {}): FormGroup {
        return new PosRules().getPosDiscountStoreForm(formFrom);
    }

    getReceiptStoreForm(formFrom: ObjectLike = {}): FormGroup {
        return new ReceiptRules().getStoreForm(formFrom);
    }

    getServiceStoreForm(formFrom: ObjectLike = {}): FormGroup {
        return new ServiceRules().getStoreForm(formFrom);
    }

    getServiceTicketStoreForm(formFrom: ObjectLike = {}): FormGroup {
        return new ServiceTicketRules().getStoreForm(formFrom);
    }

    getServiceTicketUpdateForm(formFrom: ObjectLike = {}): FormGroup {
        return new ServiceTicketRules().getUpdateForm(formFrom);
    }

    getUserAcceptTermsForm(formFrom: ObjectLike = {}): FormGroup {
        return new UserRules().getAcceptTermsForm(formFrom);
    }

    getUserContactSettingsForm(formFrom: ObjectLike = {}): FormGroup {
        return new UserRules().getContactSettingsForm(formFrom);
    }

    getUserGeneralSettingsForm(formFrom: ObjectLike = {}): FormGroup {
        return new UserRules().getGeneralSettingsForm(formFrom);
    }

    getUserGeneralSettingsHashForm(formFrom: ObjectLike = {}): FormGroup {
        return new UserRules().getGeneralSettingsHashForm(formFrom);
    }

    getUserRedeemForm(formFrom: ObjectLike = {}): FormGroup {
        return new UserRules().getUserRedeemForm(formFrom);
    }

    getUserRegistrationForm(formFrom: ObjectLike = {}): FormGroup {
        return new UserRules().getRegistrationForm(formFrom);
    }

    getUserResetForm(formFrom: ObjectLike = {}): FormGroup {
        return new UserRules().getResetForm(formFrom);
    }

    getUserSecurityForm(formFrom: ObjectLike = {}): FormGroup {
        return new UserRules().getSecurityForm(formFrom);
    }

    getUserUpdateForm(formFrom: ObjectLike = {}): FormGroup {
        return new UserRules().getUserUpdateForm(formFrom);
    }

    getUsergroupStoreEmployeeForm(formFrom: ObjectLike = {}): FormGroup {
        return new UserRules().getUsergroupStoreForm(formFrom);
    }

    getUsergroupUpdateEmployeeForm(formFrom: ObjectLike = {}): FormGroup {
        return new UserRules().getUsergroupUpdateEmployeeForm(formFrom);
    }

    getUsergroupUpdateForm(formFrom: ObjectLike = {}): FormGroup {
        return new UserRules().getUsergroupUpdateForm(formFrom);
    }

    getUsergroupUpdateHashForm(formFrom: ObjectLike = {}): FormGroup {
        return new UserRules().getUsergroupUpdateHashForm(formFrom);
    }

    getUsergroupExceptionsForm(formFrom: ObjectLike = {}): FormGroup {
        return new UserRules().getUsergroupExceptionsForm(formFrom);
    }

    getWithdrawalStoreForm(formFrom: ObjectLike = {}): FormGroup {
        return new AccountRules().getUsergroupWithdrawalForm(formFrom);
    }
}
